import React, { Fragment } from 'react';
import { Patient } from '../store/types/patient';
import PatientPhoneAutoSuggest, { getErrorComp } from './PatientPhoneAutoSuggest';
import { INVALID_PHONE_NUMBER } from './common/constants/add-patient';
import { CountryCode } from 'libphonenumber-js';

const PatientPhoneAutoSuggestBlock: React.FC<{
    phCode: string;
    phCodeEnum?: CountryCode;
    phoneNumber: string;
    onPhoneNumberChange: (input?: string) => void;
    onPhCodeChange?: (input?: string) => void;
    onAutoComplete: (patient?: Patient) => void;
    suggestionsEnabled: boolean;
    disabled: boolean;
    isPhoneNumberError: boolean;
    onBlur?: any;
    isModal: boolean;
    cid?: string;
    isAbdmEnabled: boolean | undefined;
    fromNdhmDiscovery: boolean | undefined;
}> = ({
    phCode,
    phoneNumber,
    onPhCodeChange,
    disabled,
    isPhoneNumberError,
    onAutoComplete,
    onPhoneNumberChange,
    suggestionsEnabled,
    onBlur,
    isModal,
    phCodeEnum,
    cid,
    isAbdmEnabled,
    fromNdhmDiscovery,
}) => {
    return (
        <Fragment>
            <PatientPhoneAutoSuggest
                phCode={phCode}
                inputValue={phoneNumber ?? ''}
                onCountryCodeChange={onPhCodeChange}
                onInputChange={onPhoneNumberChange}
                onSelect={onAutoComplete}
                suggestionsEnabled={suggestionsEnabled}
                disabled={disabled}
                isModal={isModal}
                onBlur={onBlur}
                className={!isModal ? 'w-50p' : ''}
                autoFocus={true}
                phCodeEnum={phCodeEnum}
                cid={cid}
                isAbdmEnabled={isAbdmEnabled}
                fromNdhmDiscovery={fromNdhmDiscovery}
            />
            {isPhoneNumberError && <div className="mt-8">{getErrorComp(INVALID_PHONE_NUMBER)}</div>}
        </Fragment>
    );
};

export default PatientPhoneAutoSuggestBlock;
